import { store } from '@atredux/store'
import {
    getStoreId,
    getSelectedStoreId,
    getStoreInfo,
    getCurrentDomainAndRegion,
    getCurrentDomain,
    getCurrentCountryCode,
    getCurrentRegion,
} from '@atredux/selectors/storeSelector'
import { getCurrentDevice } from '@atredux/selectors/deviceSelector'
import { getZoneInfo } from '@atredux/selectors/zoneSelector'
import { loadDeviceId } from '@utils/DeviceUtil'

// TODO: Replace with real data
export async function loadAppInfoListener () {
    const storeId = getStoreId(store.getState()) || getSelectedStoreId(store.getState())
    const device = getCurrentDevice(store.getState())
    return Promise.resolve({
        badgeId : '1234',         // Support ended with IhmLogin; leaving stubbed response for backwards compatibility
        store : storeId,
        domain : getCurrentDomain(store.getState()),
        // TODO: STORE ISOLATION: DomainAndRealm will be deprecated and will be removed
        domainAndRealm : getCurrentDomainAndRegion(store.getState()),
        awsAuth: '',
        device: {
            ...device,
            deviceId: device?.deviceId || loadDeviceId(),
        },
        region: getCurrentRegion(store.getState()),
        storeInfo : getStoreInfo(store.getState()),
        zoneInfo: getZoneInfo(store.getState()),
        countryCode: getCurrentCountryCode(store.getState()),
    })
}
